import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    button: {
        fontWeight: 600,
        width: 150,
    },
    container: {
        [theme.breakpoints.down("sm")]: {
            order: 2,
        },
    },
}))
